import React, { useState } from 'react';
import styles from './ProductBanner.module.scss';

import icon1 from '@/assets/images/组-2388@2x.png';
import icon2 from '@/assets/images/组 2388@2x (1).png';



interface MediaItem {
  url: string;
  type: 'image' | 'video';
  thumbnail?: string; // 视频封面
}

interface ProductBannerProps {
  imgList: string[] | MediaItem[]; // 兼容旧格式
  // children: React.ReactNode;
  // getMessage?: (str: string) => void; // 可选的回调函数
}

const ProductBanner: React.FC<ProductBannerProps> = ({imgList}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  // 标准化媒体列表格式(兼容旧的string[]格式)
  const mediaList: MediaItem[] = imgList.map(item => 
    typeof item === 'string' 
      ? { url: item, type: 'image' as const }
      : item
  );

  const prev = () => {
    setActiveIndex((prev) => (prev === 0 ? mediaList.length - 1 : prev - 1));
  }

  const next = () => {
    setActiveIndex((prev) => (prev === mediaList.length - 1 ? 0 : prev + 1));
  }

  const currentMedia = mediaList[activeIndex];

  // 如果没有媒体数据,返回空
  if (!mediaList || mediaList.length === 0 || !currentMedia) {
    return <div className={styles['product-banner']}></div>;
  }

  return (
    <div className={styles['product-banner']}>
      <div className={styles['thumb-list']}>
        <div className={styles['thumb-arrow']} onClick={prev}>
          <img src={icon1} alt="" />
        </div>
        {mediaList.map((item, idx) => (
          <div
            key={idx}
            className={
              styles['thumb-item'] +
              (activeIndex === idx ? ' ' + styles['active'] : '')
            }
            style={{ backgroundImage:`url(${item.type === 'video' && item.thumbnail ? item.thumbnail : item.url})`  }}
            onClick={() => setActiveIndex(idx)}
          />
        ))}
        <div className={styles['thumb-arrow']} onClick={next}>
          <img src={icon2} alt="" />
        </div>
      </div>
      <div className={styles['main-image']} >
        {currentMedia.type === 'video' ? (
          <video 
            src={currentMedia.url} 
            controls 
            poster={currentMedia.thumbnail}
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        ) : (
          <img src={currentMedia.url} alt="" />
        )}
      </div>
    </div>
  );
};

export default ProductBanner; 